import { useInfiniteQuery } from "vue-query";
import httpClient from "@/http/httpClient";
import store from "@/store";
import { reactive } from "vue";

export const USERS_QUERY_KEY = "settings-users";

const fetchUsers = async ({ pageParam = 1 }, search) => {
  const params = { page: pageParam };
  if (search) params["filter[search]"] = search;

  const response = await httpClient.get("settings/user-management/users", {
    params,
  });

  return {
    users: response.data.data,
    pagination: response.data.pagination,
  };
};

export default function useGetUsersInfinite(search) {
  const queryKey = reactive([USERS_QUERY_KEY, { search }]);

  return useInfiniteQuery(
    queryKey,
    (params) => fetchUsers(params, search.value),
    {
      getNextPageParam: (lastPage) => {
        const { current_page, total_pages } = lastPage.pagination;
        return current_page < total_pages ? current_page + 1 : undefined;
      },
      refetchOnWindowFocus: false,
      onError: (error) => {
        store.commit("errorsModal/openModal", error.response?.data?.errors);
      },
    }
  );
}
